/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.separator {
  --cpd-separator-color: var(--cpd-color-separator-primary);
  --cpd-separator-size: 1px;

  background-color: var(--cpd-separator-color);
}

.separator[data-kind="secondary"] {
  --cpd-separator-color: var(--cpd-color-separator-secondary);
}

.separator[data-kind="section"] {
  --cpd-separator-size: 2px;
}

.separator[data-orientation="horizontal"] {
  margin-block: var(--cpd-separator-spacing);
  margin-inline: var(--cpd-separator-inset);
  block-size: var(--cpd-separator-size);
}

.separator[data-orientation="vertical"] {
  margin-inline: var(--cpd-separator-spacing);
  margin-block: var(--cpd-separator-inset);
  inline-size: var(--cpd-separator-size);
}

@media (forced-colors: active) {
  .separator {
    outline: 1px solid transparent;
  }
}
